<template>
	<div>
		<iframe id="viewerId" :src="iframeUrl" style="width:100%; height: 90vh"></iframe>
		<!-- <iframe id="viewerId" :src="iframeUrl" style="width:100%; height: 94.8vh"></iframe> -->
	</div>
</template>

<script>
export default {
	props: [
		'iframeUrl',
	]
}

</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/general/file/viewer/detail/ViewerFrame.vue